import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import { ApplicationDataAPI } from "../../API/ApplicationDataAPI";

const useStyles = makeStyles(() => ({
	textField: {
		marginBottom: 8,
	},
	submitBtn: {
		width: 100,
		color: "white",
		backgroundColor: "#1976d2",
		"&:hover": {
			color: "white",
			backgroundColor: "#1976d2",
		},
	},
}));

const NewNote = ({ app, onNoteSaved, setCanCloseNotes }) => {
	const classes = useStyles();

	const { register, handleSubmit, errors } = useForm();
	const [note, setNote] = useState({});
	const [saving, setSaving] = useState(false);

	const saveNote = async () => {
		note.application_id = app.id;
		note.application_status = app.status;
		await ApplicationDataAPI.postNote(note, "ALL", app.locked_by_email);
	};

	const resetForm = () => {
		const note = {
			subject: "",
			message: "",
		};
		setNote(note);
		setCanCloseNotes?.(true);// eslint-disable-line no-unused-expressions
	};

	const onSubmit = async () => {
		try {
			setSaving(true);
			await saveNote();
			resetForm();
			onNoteSaved(note);
		} catch (e) {
			alert("error while saving data.");
		} finally {
			setSaving(false);
		}
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Box sx={{ display: "flex", flexDirection: "column" }}>
				<TextField
					name="txtNoteSubject"
					placeholder="Subject"
					variant="outlined"
					inputRef={register({ required: true })}
					error={Boolean(errors && errors.txtNoteSubject)}
					onChange={(e) => {
						setNote({ ...note, subject: e.target.value });
						setCanCloseNotes?.(e.target.value === "");// eslint-disable-line no-unused-expressions
					  }}
					value={note.subject}
					className={classes.textField}
					InputProps={{ style: { fontSize: 14 } }}
				/>
				<TextField
					name="txtNoteMessage"
					placeholder="Message"
					variant="outlined"
					multiline={true}
					minRows={2}
					maxRows={5}
					inputRef={register({ required: true })}
					error={Boolean(errors && errors.txtNoteMessage)}
					value={note.message}
					onChange={(e) => {
						setNote({ ...note, message: e.target.value });
						setCanCloseNotes?.(e.target.value === "");// eslint-disable-line no-unused-expressions
					  }}
					  
					className={classes.textField}
					InputProps={{ style: { fontSize: 14 } }}
				/>
				<Box sx={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
					<Button
						type="submit"
						variant="contained"
						disabled={saving}
						className={classes.submitBtn}
						startIcon={saving && <CircularProgress size={20} />}>
						Send
					</Button>
				</Box>
			</Box>
		</form>
	);
};

export default NewNote;
